<!-- 个人信息 弹窗 -->
<template>
  <lzd-modal
    title="个人信息"
    v-model="visible"
    @closed="handleClosed"
    style="max-width: 90%; padding: 0"
    :body-style="{
      padding: 0,
      background: 'var(--ele-layout-bg)',
      minHeight: '100%'
    }"
    :size="1200"
    :direction="'rtl'"
    :withHeader="true"
    :inner="false"
  >
    <user-profile />
  </lzd-modal>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import UserProfile from '@/views/user/profile/index.vue';
  /** 弹窗是否打开 */
  const visible = defineModel({ type: Boolean });

  /** 提交loading */
  const loading = ref<boolean>(false);

  const handleClosed = () => {
    loading.value = false;
  };
</script>
